import React, { Component } from 'react';
import { withTheme } from 'styled-components';
import { AbstractChart } from 'containers/charts/AbstractChart';
import { isEqual } from 'lodash';
import ContentTile from 'components/atoms/layout/ContentTile';
import ContentHeader from 'components/atoms/layout/ContentHeader';
import helpers from 'helpers';

const quartiles = {
    remainder: '< 25% Complete',
    first_quartile_completions: '25% Complete',
    midpoint: '50% Complete',
    third_quartile_completions: '75% Complete',
    ninety_fifth_percentile_completions: '95% Complete',
    completed_plays: '100% Complete'
};

class VideoQuartileChart extends Component {
    constructor(props) {
        super(props);
        this.chartRef = React.createRef();
    }

    shouldComponentUpdate(nextProps) {
        return !isEqual(nextProps, this.props);
    }

    render() {
        const { orderedColors } = this.props.theme;
        const { chartRef } = this;
        const series = [];
        [
            'completed_plays',
            this.props.social ? 'ninety_fifth_percentile_completions' : null,
            'third_quartile_completions',
            'midpoint',
            'first_quartile_completions',
            // NOTE: Removing remainder for now since there are some questions about it.
            // 'remainder'
        ].filter(e => e).forEach((key, index) => {
            let completeData;
            if (key === 'remainder') {
                completeData = helpers.backfill(
                    this.props.data.map(r => ({
                        x: r.date_in_ms,
                        y: 100 * ((r.started_plays - r.first_quartile_completions) / r.started_plays)
                    })),
                    this.props.backfillBuckets
                );
            } else {
                completeData = helpers.backfill(
                    this.props.data.map(r => ({
                        x: r.date_in_ms,
                        y: 100 * (r[key] / r.started_plays)
                    })),
                    this.props.backfillBuckets
                );
            }

            series.push({
                name: quartiles[key],
                color: orderedColors[index % orderedColors.length],
                data: completeData
            });
        });
        // We want left to right 0 -> 100% complete, but we want the colors to be
        // assigned in 100 blue, 75 red, etc.
        series.reverse();

        const xAxis = helpers.xAxisConfig({ type: 'datetime' });

        const yAxis = helpers.yAxisConfig({
            yAxisLabel: this.props.yAxisLabel,
            options: {
                labels: {
                    formatter() {
                        return `${this.value}%`;
                    }
                },
                max: 100
            }
        });

        const plotOptions = {
            series: {
                animation: {
                    duration: this.props.animateDuration,
                }
            },
            column: {
                borderWidth: 0
            }
        };

        return (
            <ContentTile padding={helpers.contentPadding('chart-with-legend')}>
                <ContentHeader chartRef={chartRef} type={'chart'}>{this.props.title}</ContentHeader>
                <AbstractChart
                    ref={chartRef}
                    exportName={this.props.exportName}
                    config={{
                        meta: {
                            title: this.props.title
                        },
                        chart: {
                            type: 'column',
                            backgroundColor: 'rgba(255, 255, 255, 0.0)',
                            zoomType: 'xy'
                        },
                        exporting: helpers.commonExportingConfig(this.props.exportName),
                        legend: {
                            padding: 10,
                            itemStyle: {
                                color: this.props.theme.charts.axisAssets
                            }
                        },
                        credits: {
                            enabled: false
                        },
                        plotOptions,
                        title: {
                            text: null
                        },
                        tooltip: {
                            pointFormat: '<span style="color:{series.color}">{series.name}</span>: <b>{point.y:.2f}%</b><br/>',
                            formatter(tooltip) {
                            // We want the tooltip to put 100% at the top and 0% on the bottom
                                this.points.reverse();

                                return tooltip.defaultFormatter.call(this, tooltip);
                            },
                            shared: true,
                            followPointer: true
                        },
                        xAxis,
                        yAxis,
                        series
                    }} />
            </ContentTile>
        );
    }
}

export default withTheme(VideoQuartileChart);



// WEBPACK FOOTER //
// ./src/components/molecules/charts/VideoQuartileChart.js